// src/views/auth/ResetPassword.jsx
import React, { useState } from "react";
import { Button, Form, Input, message, Card } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";

const API_BASE = "Users/resetpassword";

function ResetPassword() {
  const { username, code } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (values) => {
    if (values.password !== values.confirm) {
      message.error("Passwords do not match");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/${encodeURIComponent(username)}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username,
          password: values.password,
          passwordResetCode: code,
        }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.message || "Failed to reset password");
      }

      message.success("Password reset successfully! Redirecting to login...");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      message.error(err.message || "Link expired or invalid");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f0f2f5", padding: "50px 20px" }}>
      <Card style={{ maxWidth: 420, margin: "0 auto" }} title="Reset Password">
        <p style={{ textAlign: "center", marginBottom: 20 }}>
          Set a new password for <strong>{username}</strong>
        </p>

        <Form form={form} onFinish={onSubmit} layout="vertical">
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Enter new password" }]}
          >
            <Input.Password size="large" placeholder="New Password" />
          </Form.Item>

          <Form.Item
            name="confirm"
            rules={[{ required: true, message: "Confirm password" }]}
          >
            <Input.Password size="large" placeholder="Confirm Password" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading} size="large">
              Reset Password
            </Button>
          </Form.Item>

          <div style={{ textAlign: "center" }}>
            <Link to="/">Back to Login</Link>
          </div>
        </Form>
      </Card>
    </div>
  );
}

export default ResetPassword;